export default "<div id=groupRejectsChart> <canvas id=chart></canvas> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/controllers/counts/equipmentGroupRejectsGraph.tpl.html
// module id = 524
// module chunks = 0